import { ActionReducerMap } from '@ngrx/store';
import { appMetaReducer, AppMetaState } from './app-meta/app-meta.reducer';
import { configReducer, ConfigState } from './config/config.reducer';

export interface AppState {
  appMetaState: AppMetaState;
  configState: ConfigState;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const appReducer: ActionReducerMap<AppState, any> = {
  appMetaState: appMetaReducer,
  configState: configReducer
};
